import { __decorate } from "tslib";
import { provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import { RouterLinkResolverService } from '@core/shared/feature';
import * as i0 from "@angular/core";
let PflegethekeAppFrontendFeature = /*#__PURE__*/(() => {
  let PflegethekeAppFrontendFeature = class PflegethekeAppFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@pflegetheke/app/frontend","featureId":"pflegetheke-app"};
    }
    getFeatureFunctionality(functionality) {
      const resolver = this.injector.get(RouterLinkResolverService);
      functionality.defineMenuItems({
        toolbar: [{
          label: 'Anmelden',
          icon: 'unlock',
          routerLink: resolver.resolveRouterLink('frontend', 'login'),
          simpleAbilityCheck: {
            allow: ['!REGISTERED']
          }
        }, {
          label: 'Mein Profil',
          icon: 'user',
          routerLink: resolver.resolveRouterLink('frontend', 'profile'),
          simpleAbilityCheck: {
            allow: [['REGISTERED', '!MANAGER']]
          }
        }, {
          label: 'Management',
          icon: 'user',
          routerLink: resolver.resolveRouterLink('frontend', 'management'),
          simpleAbilityCheck: {
            allow: ['MANAGER']
          }
        }, {
          label: 'Themen',
          icon: 'chalkboard-teacher',
          routerLink: resolver.resolveRouterLink('frontend', 'questionCategories')
        },
        // { label: 'Neues', icon:'bell', routerLink:resolver.resolveRouterLink('frontend','notifications'), simpleAbilityCheck:{allow:[['REGISTERED']]}, 
        //	id:'notifications' /* ID required to add custom notification-icon */ },
        {
          label: 'Hilfe',
          icon: 'question-circle',
          routerLink: resolver.resolveRouterLink('frontend', 'faq')
        }, {
          label: 'Menu',
          icon: 'bars',
          declareGroup: 'toolbar/more',
          items: [{
            label: 'Erklärung zur Barrierefreiheit',
            icon: 'info-circle',
            routerLink: 'accessibility-declaration'
          }, {
            label: 'Datenschutz',
            icon: 'user-shield',
            routerLink: 'privacy'
          }, {
            label: 'Impressum',
            icon: 'info-circle',
            routerLink: 'imprint'
          }, {
            label: 'AGB',
            icon: 'info-circle',
            routerLink: 'terms'
          }, {
            label: 'Logout',
            icon: 'lock',
            routerLink: resolver.resolveRouterLink('frontend', 'logout'),
            simpleAbilityCheck: {
              allow: ['REGISTERED']
            }
          }]
        }]
      });
      functionality.defineRouterLinkRedirects([{
        matcher: '/user/login',
        redirect: '/login',
        type: 'Replace' // wtf? this is working everywhere else too, just here ts states there is a type Error.
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵPflegethekeAppFrontendFeature_BaseFactory;
        return function PflegethekeAppFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵPflegethekeAppFrontendFeature_BaseFactory || (ɵPflegethekeAppFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(PflegethekeAppFrontendFeature)))(__ngFactoryType__ || PflegethekeAppFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: PflegethekeAppFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'imprint',
          data: {
            pageTitle: 'Impressum'
          },
          loadComponent: () => import('./components/imprint.component').then(m => m.PflegethekeImprintComponent)
        }, {
          path: 'privacy',
          data: {
            pageTitle: 'Datenschutz'
          },
          loadComponent: () => import('./components/privacy.component').then(m => m.PflegethekePrivacyComponent)
        }, {
          path: 'terms',
          data: {
            pageTitle: 'AGB'
          },
          loadComponent: () => import('./components/terms.component').then(m => m.PflegethekeTermsComponent)
        }, {
          path: 'accessibility-declaration',
          data: {
            pageTitle: 'Erklärung zur Barrierefreiheit'
          },
          loadComponent: () => import('./components/accessibility-declaration.component').then(m => m.PflegethekeAccessibilityDeclarationComponent)
        }])]
      });
    }
  };
  PflegethekeAppFrontendFeature = __decorate([ClassName("PflegethekeAppFrontendFeature")], PflegethekeAppFrontendFeature);
  return PflegethekeAppFrontendFeature;
})();
export { PflegethekeAppFrontendFeature };